<!-- eslint-disable no-console -->
<script setup lang='ts'>
import { logicPartItem } from '~/logic/common/part'
import { LOAD_STATE } from '~/shared/types'

const props = withDefaults(defineProps<{
  fid: number
  partsClasszId?: null | number
  label: string
  value: string | number
  activeValues: string[] // value-partId
}>(), {})
const emits = defineEmits({
  change: (_value: string) => true,
})
const { state, partsMap, getPart } = logicPartItem()

const active = computed(() => {
  if (!props.activeValues.length)
    return false
  for (const v of props.activeValues) {
    if (!props.partsClasszId && v === `${props.fid}-${props.value}`)
      return true
    if (props.partsClasszId && v.split('-')[1] === String(props.value))
      return true
  }
})
const activePartId = computed(() => {
  if (!props.partsClasszId || !active.value)
    return ''
  const value = props.activeValues.find(v => v.split('-')[1] === String(props.value))
  if (!value)
    return ''
  return value.split('-')[2]
})
function getSelectLabelKey() {
  if (!props.partsClasszId || !active.value)
    return ''
  const value = props.activeValues.find(v => v.split('-')[1] === String(props.value))
  if (!value)
    return ''
  const splitArr = value.split('-')
  if (splitArr && splitArr[3])
    return splitArr[3]
}

async function load() {
  if (!props.partsClasszId || state.value === LOAD_STATE.LOADING)
    return
  await getPart(props.partsClasszId)
}
</script>

<template>
  <div class="pui-checkbox ">
    <span v-if="!props.partsClasszId" class="pui-checkbox-item" :class="{ 'is-active': active }" @click.capture="emits('change', `${props.fid}-${props.value}`)">{{ props.label }}</span>
    <span v-else @wheel.stop>
      <NPopover placement="bottom" trigger="click" raw :offset="20" @update:show="load">
        <template #trigger>
          <div class="pui-checkbox-item relative" :class="{ 'is-active': active }">
            <span class="pr-2.5">{{ props.label + (active && getSelectLabelKey() ? `-${getSelectLabelKey()}` : '') }}</span>
            <i class="i-ep:arrow-down absolute right-1" />
          </div>
        </template>
        <div class="pl-2 py-1 bg-white " @wheel.stop="null">
          <UtilLoadState :state="state" :reload-handler="load">
            <div class="h-50 overflow-auto scrollbar-default">
              <div
                v-for="(val, idx) in partsMap.get(props.partsClasszId)" :key="idx"
                class="select-item cursor-pointer" :class="{ 'is-active': activePartId === String(val.id) }"
                @click="emits('change', `${props.fid}-${props.value}-${val.id}-${val.name}`)"
              >{{ val.name }}</div>
            </div>
          </UtilLoadState>
        </div>
      </NPopover>
    </span>
  </div>
</template>

<style  lang='scss'>
.el-popover.el-popper.popover-item {
  padding: 0;
}
</style>

<style lang='scss' scoped>
.pui-checkbox {
  display: flex;
  flex-wrap: wrap;
  &-item {
    display: inline-block;
    height: 32px;
    border-radius: 6px;
    margin-right: 12px;
    margin-bottom: 12px;
    padding: 9px 15px;
    border: 1px solid theme('colors.slate.300');
    font-size: 12px;
    line-height: 1;
    cursor: pointer;
    transition: all 0.2s;

    &.is-active {
      background-color: theme('colors.blue.500');
      color: #fff;
    }

    &:not(.is-active):hover {
      background: rgba(71, 138, 250, 0.2);
      border-color: rgba(71, 138, 250, 0.2);
    }
  }
}

.select-item {
  line-height: 35px;
  padding: 0 12px;
  text-align: center;

  &:hover {
    background: rgba(242, 245, 250, 0.4);
  }

  &.is-active {
    color: theme('colors.blue.500');
    font-weight: bold;
  }
}
</style>
